import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TProcessChecksByEmployerCheckIdRequestSchema,
  TProcessChecksByEmployerCheckIdResponseSchema,
} from "./processChecksByEmployerCheckId.schema";

export const processChecksByEmployerCheckId = (axios: IAxiosInstance) => {
  return async (body: TProcessChecksByEmployerCheckIdRequestSchema) => {
    const response =
      await axios.noRetry.post<TProcessChecksByEmployerCheckIdResponseSchema>(
        `/api/picard/processByID`,
        body
      );

    return response.data;
  };
};
